import { useNavigate } from 'react-router-dom';
import '_Asset/css/User/Page/forbidden.css'

const Forbidden = () => {

  const navigate = useNavigate()


  return (
    <div className="forbidden">
      <div className="inner">
        <button type="button" className="closeIco" onClick={() => navigate(-1)}></button>
        <span>404 Page</span>

        <div className="forbIco">
          <i className="icofont-exclamation-circle"></i>
        </div>

        <div className="forbTxtGroup">
          <h1 className="errCode">404</h1>

          <p className="errTit">Page Not Found!</p>
          <span className="txtMsg">
            We're sorry, the page you requested could not be found. please go back to the homepage.
          </span>
          <button type="button" className="btn md round_10 sfrtBlue" onClick={() => navigate(-1)}><i className="icofont-swoosh-left"></i>Go Back</button>
        </div>
        
      </div>
   </div>
  )
}

export default Forbidden;